import { useState } from 'react'
import { ArtistDetail } from '../../types/artist'
import { formatNumber } from '../../utils'
import styles from './Artists.module.css'

function stripDiscogsMarkup(text: string): string {
  return text
    .replace(/\[url=[^\]]+\]([^\[]*)\[\/url\]/g, '$1')
    .replace(/\[b\]([^\[]*)\[\/b\]/g, '$1')
    .replace(/\[i\]([^\[]*)\[\/i\]/g, '$1')
    .replace(/\[a=([^\]]+)\]/g, '$1')
    .replace(/\[l=([^\]]+)\]/g, '$1')
    .replace(/\[\/?[^\]]+\]/g, '')
    .trim()
}

interface ArtistHeaderProps {
  artist: ArtistDetail
}

export function ArtistHeader({ artist }: ArtistHeaderProps) {
  const [expanded, setExpanded] = useState(false)
  const profile = artist.profile ? stripDiscogsMarkup(artist.profile) : null

  return (
    <div className={styles.entityHeader}>
      <div className={styles.entityAvatar}>
        {artist.cover_image ? (
          <img src={artist.cover_image} alt={artist.name} />
        ) : (
          <div className={styles.entityNoImage}>
            <i className="bi bi-person-fill"></i>
          </div>
        )}
      </div>

      <div className={styles.entityInfo}>
        <div className={styles.entityName}>{artist.name}</div>
        {artist.realname && (
          <div className={styles.entitySubtitle}>{artist.realname}</div>
        )}

        <div className={styles.entityStats}>
          <span>{formatNumber(artist.release_count)} releases</span>
          {artist.total_want > 0 && <span>{formatNumber(artist.total_want)} wants</span>}
        </div>

        {profile && (
          <div className={styles.entityBio}>
            <p className={expanded ? styles.bioExpanded : styles.bioClamped}>
              {profile}
            </p>
            {profile.length > 200 && (
              <button className={styles.bioToggle} onClick={() => setExpanded(e => !e)}>
                {expanded ? 'Show less' : 'Show more'}
              </button>
            )}
          </div>
        )}

        {artist.urls && artist.urls.length > 0 && (
          <div className={styles.entityUrls}>
            {artist.urls.slice(0, 5).map((url, i) => {
              try {
                const label = new URL(url).hostname.replace('www.', '')
                return <a key={i} href={url} target="_blank" rel="noopener noreferrer" className={styles.entityUrl}>{label}</a>
              } catch { return null }
            })}
          </div>
        )}
      </div>
    </div>
  )
}
